import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "us" }
const _hoisted_2 = {
  key: 0,
  class: "us-empty"
}
const _hoisted_3 = {
  key: 1,
  class: "us-empty",
  role: "alert"
}
const _hoisted_4 = {
  key: 2,
  class: "us-empty",
  role: "status"
}
const _hoisted_5 = { class: "us-kicker" }
const _hoisted_6 = {
  class: "us-strip",
  "aria-label": "Last 30 days, all companies"
}
const _hoisted_7 = { class: "us-stat-n" }
const _hoisted_8 = { class: "us-stat-l" }
const _hoisted_9 = {
  key: 0,
  class: "us-stat-s"
}
const _hoisted_10 = {
  key: 0,
  class: "us-warn",
  role: "note"
}
const _hoisted_11 = { class: "us-tablewrap" }
const _hoisted_12 = { class: "us-table" }
const _hoisted_13 = ["aria-sort"]
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = {
  key: 0,
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "us-id" }
const _hoisted_17 = { class: "us-tablewrap" }
const _hoisted_18 = { class: "us-table" }
const _hoisted_19 = { class: "us-name" }
const _hoisted_20 = { class: "us-num" }
const _hoisted_21 = { class: "us-num" }
const _hoisted_22 = { class: "us-num" }
const _hoisted_23 = { class: "us-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/ai-hub?tab=health",
        class: "us-back"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("← Back to The Forge", -1)
        ]))]),
        _: 1
      }),
      (_ctx.denied)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "This page is only available to IronBook administrators."))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "us-retry",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load()))
              }, "Try again")
            ]))
          : (!_ctx.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading IronBook usage…"))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_5, "IronBook usage · every company · as of " + _toDisplayString(_ctx.generated), 1),
                _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "us-title" }, "Who is using IronBook", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "us-lede" }, "Counts per company. \"Active\" means a team login opened IronBook in that window. Activity columns cover the last 30 days.", -1)),
                _createElementVNode("section", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strip, (s) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: s.label,
                      class: "us-stat"
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(s.value), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(s.label), 1),
                      (s.sub)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(s.sub), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                (_ctx.data.unavailable?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Some numbers could not be read and show as 0: " + _toDisplayString(_ctx.data.unavailable.join(', ')) + ".", 1))
                  : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "us-h" }, "By company", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "us-hint" }, "Click a column heading to sort.", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("table", _hoisted_12, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: c.key,
                            scope: "col",
                            class: _normalizeClass([c.key == 'name' ? 'us-name' : 'us-num', _ctx.sortKey == c.key ? 'us-sorted' : '']),
                            "aria-sort": _ctx.sortKey == c.key ? (_ctx.sortDir > 0 ? 'ascending' : 'descending') : 'none'
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "us-sort",
                              title: c.title,
                              onClick: ($event: any) => (_ctx.sortBy(c.key))
                            }, [
                              _createTextVNode(_toDisplayString(c.label), 1),
                              (_ctx.sortKey == c.key)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.sortDir > 0 ? ' ▲' : ' ▼'), 1))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_14)
                          ], 10, _hoisted_13))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sorted, (row) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row.id,
                          class: _normalizeClass(row.id == _ctx.ownCompany ? 'us-own' : '')
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: c.key,
                              class: _normalizeClass(c.key == 'name' ? 'us-name' : 'us-num')
                            }, [
                              (c.key == 'name')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(row.name) + " ", 1),
                                    _createElementVNode("span", _hoisted_16, "#" + _toDisplayString(row.id), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(_ctx.fmt(c, c.get(row))), 1)
                                  ], 64))
                            ], 2))
                          }), 128))
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: c.key,
                            class: _normalizeClass(c.key == 'name' ? 'us-name' : 'us-num')
                          }, [
                            (c.key == 'name')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("All companies")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.fmt(c, c.get(_ctx.data.totals))), 1)
                                ], 64))
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "us-h" }, "Published content by type", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("th", {
                          scope: "col",
                          class: "us-name"
                        }, "Company", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (t) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: t,
                            scope: "col",
                            class: "us-num"
                          }, _toDisplayString(_ctx.typeLabel(t)), 1))
                        }), 128)),
                        _cache[3] || (_cache[3] = _createElementVNode("th", {
                          scope: "col",
                          class: "us-num"
                        }, "Folders", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("th", {
                          scope: "col",
                          class: "us-num",
                          title: "Drafts, waiting for approval and inactive"
                        }, "Unpublished", -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.companies, (row) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row.id,
                          class: _normalizeClass(row.id == _ctx.ownCompany ? 'us-own' : '')
                        }, [
                          _createElementVNode("td", _hoisted_19, _toDisplayString(row.name), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (t) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: t,
                              class: "us-num"
                            }, _toDisplayString(_ctx.num(row.content.publishedByType[t] || 0)), 1))
                          }), 128)),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.num(row.content.folders)), 1),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.num(row.content.drafts + row.content.awaitingApproval + row.content.inactive)), 1)
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("td", { class: "us-name" }, "All companies", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (t) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: t,
                            class: "us-num"
                          }, _toDisplayString(_ctx.num(_ctx.data.totals.content.publishedByType[t] || 0)), 1))
                        }), 128)),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.num(_ctx.data.totals.content.folders)), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.num(_ctx.data.totals.content.drafts + _ctx.data.totals.content.awaitingApproval + _ctx.data.totals.content.inactive)), 1)
                      ])
                    ])
                  ])
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("ul", { class: "us-notes" }, [
                  _createElementVNode("li", null, "Admin logins have no last sign-in time, so \"Editors\" counts the different people who changed content in the last 30 days."),
                  _createElementVNode("li", null, "People counts (team logins, editors, AI users) are per company. Someone in two companies counts in both."),
                  _createElementVNode("li", null, "AI cost is IronBook's own estimate from tokens at list prices. It is for IronBook only; customers never see it.")
                ], -1))
              ], 64))
    ])
  ], 2))
}